module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.resourceLoaded) ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.resourceLoaded) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row payment-tab-container"
  }, [_c('table', {
    staticClass: "superconciergerie-table-secondary table text-center",
    staticStyle: {
      "min-width": "1280px"
    },
    attrs: {
      "id": "reservations-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.rental_name")) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.platform")) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.guest")) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.checkin")) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.checkout")) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.nbr_nights")) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.nbr_guests")) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.total_price")) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.status")) + "\n                ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.concierge_cleaning")) + "\n                  "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-content": "Facturée par la conciergerie"
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.concierge_linen")) + "\n                  "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-content": "Facturée par la conciergerie"
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.concierge_checkin")) + "\n                  "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-content": "Facturée par la conciergerie"
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.concierge_commission")) + "\n                  "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-content": "Base de calcul x taux commission"
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("superconcierge.reservations.concierge_fees")) + "\n                  "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-content": "Commission + forfait 1 + forfait 2"
    }
  })])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredBookings), function(booking) {
    return _c('tr', {
      key: booking.id
    }, [_c('td', [_c('div', [_c('a', {
      staticClass: "m-b-10 product-price action-title",
      attrs: {
        "href": '#/rentals/' + booking.rental_id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(booking.rental_name))])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                    " + _vm._s(booking.platform) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', [_c('a', {
      staticClass: "m-b-10 product-price action-title",
      attrs: {
        "href": '#/bookings/' + booking.id + '/informations',
        "target": "_blank"
      }
    }, [_vm._v("\n                    " + _vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name) + "\n                    ")])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                    " + _vm._s(_vm.moment(booking.checking).format("DD/MM/YYYY")) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                    " + _vm._s(_vm.moment(booking.checkout).format("DD/MM/YYYY")) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                    " + _vm._s(booking.nbr_nights) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                    " + _vm._s(booking.nbr_guests) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                    " + _vm._s(booking.total_price.toFixed(2)) + _vm._s(booking.currency) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                    " + _vm._s(_vm.$t("booking.detail.status." + booking.status)) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      },
      attrs: {
        "id": 'booking-' + booking.id + '-superconcierge_cleaning_fees'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showInputField(booking, 'superconcierge_cleaning_fees', 'booking-', _vm.updateBooking, this)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(booking.superconcierge_cleaning_fees.toFixed(2)) + "\n                    " + _vm._s(booking.currency) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      },
      attrs: {
        "id": 'booking-' + booking.id + '-superconcierge_linen_fees'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showInputField(booking, 'superconcierge_linen_fees', 'booking-', _vm.updateBooking, this)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(booking.superconcierge_linen_fees.toFixed(2)) + "\n                    " + _vm._s(booking.currency) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600"
      },
      attrs: {
        "id": 'booking-' + booking.id + '-superconcierge_checkin_fees'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showInputField(booking, 'superconcierge_checkin_fees', 'booking-', _vm.updateBooking, this)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(booking.superconcierge_checkin_fees.toFixed(2)) + "\n                    " + _vm._s(booking.currency) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600",
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "popover",
        "data-content": "Mars : 95€<br/>Avril : 100€"
      }
    }, [_vm._v("\n                    " + _vm._s(booking.concierge_commission.toFixed(2)) + "\n                    " + _vm._s(booking.currency) + "\n                  ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "font-weight": "600",
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "popover",
        "data-content": "Calcul"
      }
    }, [_vm._v("\n                    " + _vm._s(booking.concierge_fees.toFixed(2)) + "\n                    " + _vm._s(booking.currency) + "\n                  ")])])])
  }))])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38bbc096"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/superconciergerie/tabs/ReservationsTab.vue
// module id = 1353
// module chunks = 0